// extracted by mini-css-extract-plugin
export default {"cls1":"VeloForm-SubmitError_cls1__sNC+K","cls2":"VeloForm-SubmitError_cls2__07snm VeloForm-SubmitError_cls1__sNC+K"};